import React, { Component } from 'react';
import { lang } from'../Helpers/lang';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import Select from 'react-select';
import $ from 'jquery';
import { PageTitle, CheckAuth, scrollToTopValidate, scrollToTop } from "../Helpers/SettingHelper";
import { apiUrl, mediaUrl} from'../Config/Config';
import axios from 'axios';
import { computeFilterFromHex } from '../Helpers/cssFilterSolver';
const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };
class Edit extends Component {
	
	constructor(props)
	{
		super(props);
		const id = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;

		this.state = {
		  list_id : id,
	      login_type:'',
		  show_count_yes:true,
		  show_count_no:false,		 
	      name:'',
	      module_type:'',
	      module_type_value:'',
	      priorty:'',
		  content:'',
		  image_preview:'',
		  image_name:'',
		  image:'',
	      name_arr:[],
	      module_type_arr:[],
	      module_type_value_arr:[],
	      priorty_arr:[],
		  content_arr:'',
		  image_preview_arr:'',
		  image_name_arr:'',
	      showlayout: false,
	      select_options:'',
	      select_options_arr:[],
	      selectedvalue: '',
          selectedOption:{ value: 'active', label: 'Active'},
          Loading:false,
		  show_count_arr:[],
		  image_arr:[],
		  icon_image: [],
		  icon_image_arr:[],
          editindex:'',
          field_ids:[],
		  remove_ids:'',
		  removeall_ids:'',
		  login_type:'',
		   bg_image_name_arr:'',
		  bg_image_name:'',
		  bg_image_preview: '',
		  bg_image: '',
		  db_bg_image_name:'',
		  show_count: 'yes',
		  show_tooltip: 'yes',
		  icon_color:'',
		  text_color:'',
		  text_color_arr:[],
		  text_size:'',
		  text_size_arr:[],
		  count_size:'',
		  count_size_arr:[],
		  icon_image_preview_arr: '',
		  icon_image_name_arr: '',
		  enable_list:false,
		  enable_list_arr: [],
		  dashboard_img_type:'dashboard_img',
		  dashboard_img_type_arr:[],
		  dashb_img_max_height:'',
		  dashb_img_max_height_arr:[],
		  dashb_img_max_width:'',
		  dashb_img_max_width_arr:[],
		  dashb_img_position:'',
		  dashb_img_position_arr:[],
		  dashboard_blocks: [],
		  icon_color_filter: '',
		  icon_color_loss: '',
		  dashboarddata:[],
		  edit_column_id:'',
		  icon_width:'',
		  new_image_counter:0,
		  new_bgimage_counter:0,
		  block_image_counter:0,
		  filtered_page_options:[],
		  db_image_name: '',
		  db_bg_image_name:'',
		  blockCounts:{}

		};
    this.deletesinglefield = this.deletesinglefield.bind(this);
    this.getDashboardDetail();
	
		

						
						
	
	
 }

 getDashboardDetail =() =>{
   var qs = require('qs');
	var listid = this.state.list_id;

	axios.get(apiUrl+"dashboardmanagment/listdetail?id="+listid).then(res => {
		if(res.data.status == "success" ){
			var dashdata =res.data
			var filteredlinks =lang.common.dashboard_page_options.filter(item=>(item.type==dashdata.usertype));
			const formdata = res.data.data;
			const block1count = dashdata.dashboarddata.filter(item => item.dashboard_block === "block1").length;
			const block2count = dashdata.dashboarddata.filter(item => item.dashboard_block === "block2").length;
			const block3count = dashdata.dashboarddata.filter(item => item.dashboard_block === "block3").length;
			const block4count = dashdata.dashboarddata.filter(item => item.dashboard_block === "block4").length;
			
			this.setState({
				blockCounts:{
					block1:block1count,
					block2:block2count,
					block3:block3count,
					block4:block4count
				}

			})
			this.setState({
				login_type : {value:dashdata.usertype, label:dashdata.usertype},
				showlayout: true, 
				login_type_value: dashdata.usertype,
				dashboarddata:dashdata.dashboarddata,
				filtered_page_options:filteredlinks})
			if (dashdata.dashboard_blocks && dashdata.dashboard_blocks.length>0) {
			const blocksWithIds = dashdata.dashboard_blocks.map(block => ({
				...block,
				dashboard_id: this.state.list_id,
				db_bl_image_name: block.image || '',
				action: 'no'
			}));
			this.setState({ dashboard_blocks: blocksWithIds });
			}
			else{
				const dashblocks= lang.common.dashboard_blocks.map((item)=>{
                 return{"title":item.value,"label":item.label}
				})
				this.setState({ dashboard_blocks: dashblocks });
			}
		}
		}); 
					  
		// if(formdata.column_id){
		// 	this.setState({field_ids: formdata.column_id});
		// }
 }
	
	componentDidMount() {
		  	if(localStorage.getItem("admin_id") === 'undefined' && localStorage.getItem('admin_id') === '' && localStorage.getItem('admin_id') === null){
			this.props.history.push('/');
		}
  }


	handleInputChange = (event) =>{
    const { name, value, checked, type } = event.target;
    // const { name,value } = event.target;
	 this.setState({
		[name]: type === "checkbox" ? checked : value
	});
    // this.setState({[name]: value})
	if(name == "icon_color"){
		const hex = event.target.value;
		this.setState({ icon_color: hex });
		
		const { filter, loss } = computeFilterFromHex(hex);
		this.setState({ icon_color_filter: filter, icon_color_loss: loss });
	}
     if(name === 'form_column'){
       this.setState({form_one_column: !this.state.form_one_column});
       this.setState({form_two_column: !this.state.form_two_column});
    }
    if(name === 'field_required'){
        this.setState({field_required_checked: !this.state.field_required_checked});
    }
    if(name == 'select_options'){
        this.setState({select_options:value})
    }
	if (name === 'show_count') {
		this.setState({ show_count: value });
	}

	if (name === "enable_list") {
		this.setState({
		enable_list: checked 
		});
	}
	
	
  }

  handleChange = login_type => {
	this.setState({login_type})
	this.setState({  login_type_value : login_type.value});
  };

  handleDashboardBlockChange = (index, field, value) => {
	const blocks = [...this.state.dashboard_blocks];
	blocks[index] = {
		...blocks[index],
		[field]: value,
		action: blocks[index].id ? 'edit' : 'add'
	};
	this.setState({ dashboard_blocks: blocks });
  }


  handleFormSubmit = () => {
	
		this.setState({Loading:true});
			const config = {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
			};

		const formPayload = this.state;
		var qs = require('qs');
        var updatedashboarddata= formPayload.dashboarddata.filter(item => item.action === 'edit' || item.action === 'add').map(item => ({
				id: item.column_id || '',
				name: item.name || '',
				module_type_value: item.module_type_value || '',
				priorty: item.priorty || '',
				text_size: item.text_size || '',
				text_color: item.text_color || '',
				count_size: item.count_size || '',
				show_count: item.show_count || '',
				show_tooltip: item.show_tooltip,
				dashboard_block: item.dashboard_block,
				show_tooltip: item.show_tooltip,
				icon_width: item.icon_width,
				icon_color:item.icon_color,
				svg_icon_color:item.icon_color_filter,
				content: item.content || '',
				image_name: item.image_name || '',
				bg_image_name:item.bg_image_name ||'',
				icon_image_name: item.icon_image_name || '',
				db_image_name: item.db_image_name || '',
				db_bg_image_name:item.db_bg_image_name ||'',
				db_icon_image_name: item.db_icon_image_name || '',
				enable_list: item.enable_list || '',
				dashboard_img_type: item.dashboard_img_type || '',
				dashb_img_max_height: item.dashb_img_max_height || '',
				dashb_img_max_width: item.dashb_img_max_width || '',
				dashb_img_position: item.dashb_img_position || '',
				action: item.action || ''
			}))
		var updatedblockdata = formPayload.dashboard_blocks.map(block => ({
				id: block.id || '',
				dashboard_id: this.state.list_id,
				title: block.title || '',
				color: block.color || '',
				db_bl_image_name: block.db_bl_image_name || '',
				image_name: block.image_name || '',
				action: block.action
			}))
        //console.log("updatedashboarddata", updatedashboarddata);
        console.log("updatedblockdata", updatedblockdata);
		var postObject = {
			admin_id : localStorage.getItem("admin_id"),
			user: formPayload.login_type_value,
			list_id : this.state.list_id,
			//edit_id:this.state.dashboarddata[this.state.editindex].column_id,
			removeid: formPayload.remove_ids,
			removeallid: formPayload.removeall_ids,
			dashboard_data: JSON.stringify(updatedashboarddata),
			dashboard_blocks: JSON.stringify(updatedblockdata),
			
		};
		//this.props.getEditForm(qs.stringify(postObject));
		//return false;
		let formData = new FormData();

		for(let k in postObject) {
			formData.append(k, postObject[k]);
		}
		// Append images from dashboarddata array using image_name
		formPayload.dashboarddata.forEach((item) => {
			if(item.new_image && item.image_name) {
				formData.append(`update_image[${item.image_name}]`, item.new_image);
			}
			if(item.new_bg_image && item.bg_image_name) {
				formData.append(`update_bgimage[${item.bg_image_name}]`, item.new_bg_image);
			}
		});

		// Append icon images using icon_name
		formPayload.dashboarddata.forEach((item) => {
			if(item.icon_image && item.icon_image_name) {
				formData.append(`update_icon[${item.icon_image_name}]`, item.icon_image);
			}
		});

		// if (this.state.bg_image) {
		// 	formData.append("update_bgimage", this.state.bg_image);
		// }

			formPayload.dashboard_blocks.forEach((block) => {
				if (block.image && typeof block.image === 'object' && block.image_name) {
					formData.append(`dashboard_block_image[${block.image_name}]`, block.image);
				}
			});

		axios.post(apiUrl+"dashboardmanagment/edit1",formData,config).then(res => {
			if(res.data.status === "success"){
				this.setState({Loading:false});
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
				scrollToTop();
				setTimeout(function() {
					$('.success_message').html('');
					this.getDashboardDetail();
				}.bind(this), 3000);
			}else{
				$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
				scrollToTop();
				setTimeout(function() {
					$('.success_message').html('');
				}.bind(this), 3000);
			}
		});
	}


  Addtolayout = () => {
	if(this.state.name == '' ){
		return false;	
    // $('.error_name').html('<span class="errorspan">Please fill the field</span>') : $('.error_name').html('');

	}
	const Index = this.state.editindex;

	const newItem = {
		name: this.state.name,
		module_type_value: this.state.module_type_value,
		priorty: this.state.priorty,
		count_size: this.state.count_size,
		text_color: this.state.text_color,
		text_size: this.state.text_size,
		content: this.state.content,
		new_image: this.state.image,
		image_name:this.state.image_name,
		image_preview: this.state.image_preview,
		db_image_name:this.state.db_image_name,
		db_bg_image_name:this.state.db_bg_image_name,
		bg_image_name:this.state.bg_image_name,
		new_bg_image:this.state.bg_image,
		bg_image_preview: this.state.bg_image_preview,
		icon_image: this.state.icon_image,
		icon_preview: this.state.icon_preview,
		enable_list: this.state.enable_list,
		show_count: this.state.show_count,
		show_tooltip: this.state.show_tooltip,
		dashboard_block: this.state.dashboard_block,
		show_tooltip: this.state.show_tooltip,
		icon_width: this.state.icon_width,
		icon_color:this.state.icon_color,
		icon_color_filter:this.state.icon_color_filter,
		dashboard_img_type: this.state.dashboard_img_type,
		dashb_img_max_height: this.state.dashb_img_max_height,
		dashb_img_max_width: this.state.dashb_img_max_width,
		dashb_img_position: this.state.dashb_img_position,
		action: this.state.dashboarddata[Index] ?.id ? "edit":"add",
	};

	const updatedDashboardData = [...this.state.dashboarddata];

	if(Index !== ''){
		updatedDashboardData[Index] = {
			...updatedDashboardData[Index],
			...newItem
		};
	} else {
		updatedDashboardData.push(newItem);
	}

	const blockCounts = {
		block1: updatedDashboardData.filter(item => item.dashboard_block === 'block1').length,
		block2: updatedDashboardData.filter(item => item.dashboard_block === 'block2').length,
		block3: updatedDashboardData.filter(item => item.dashboard_block === 'block3').length,
		block4: updatedDashboardData.filter(item => item.dashboard_block === 'block4').length
	};

	this.setState({dashboarddata: updatedDashboardData, blockCounts: blockCounts, showlayout: true}, () => {
		this.setState({
			name: '',
			module_type_value: '',
			priorty: '',
			count_size: '',
			text_color: '',
			text_size: '',
			content: '',
			image: '',
			image_name: '',
			image_preview: '',
			icon_image: '',
			icon_name: '',
			icon_preview: '',
			editindex: '',
			new_image: '',
			bg_image_name:'',
			bg_image:'',
			bg_image_preview:'',
			db_image_name:'',
			db_bg_image_name:'',
			icon_width:'',
			icon_color:'',
			icon_color_filter:'',
			dashboard_block_sel: '',
			module_type: '',
			module_type_value:''
		});
		this.getformlayout();
		scrollToTop();
		$('#addbutton').html('Add');
	});
  }

  validateFormfield() {
		const {form_field_name,form_input_type_value,field_required,field_priorty,select_options} = this.state;
		let errors = 0;
	
		if (!form_field_name) {
			errors++;
			$('.errorfieldname').html('<span class="errorspan">Please fill the field</span>');
		}else if(form_field_name){
			$('.errorfieldname').html('');
		}


		if (!form_input_type_value) {
			errors++;
			$('.errortype').html('<span class="errorspan">Please select input type</span>');
		}else if(form_input_type_value){
			$('.errortype').html('');
		}

		if(!field_priorty){
		errors++;
			$('.errorpriority').html('<span class="errorspan">Please fill the field</span>');
		}else if(field_priorty){
			$('.errorpriority').html('');
		}

		if(form_input_type_value == 'select'){
			if(!select_options){
				errors++;
				$('.erroroptions').html('<span class="errorspan">Please fill the field</span>');
			}else if(select_options){
				$('.erroroptions').html('');
			}
		}

		if(errors>0) {
		setTimeout(function () {
		scrollToTopValidate();
		}, 100);
		return false;
		}
		else {
		return true;
		}

    }

       componentWillReceiveProps(Props){

    	   if(Props.formdetail !== this.props.formdetail){
    		if(Object.keys(Props.formdetail).length > 0){
				this.setState({Loading:false});
					if(Props.formdetail[0].status === "success"){

						const formdata = Props.formdetail[0].formdata;
						this.setState({form_name : formdata.formname});
						if(formdata.formcolumn == 1){
							this.setState({form_one_column: true,form_two_column: false});
						}else{
							this.setState({form_two_column: true,form_one_column:false})
						}
						if(formdata.formstatus === 'A'){
							this.setState({selectedOption:{value: 'active', label: 'Active'}});
						}else{
							this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
						}
					
					  	if(formdata.field){
					  		this.setState({name_arr: formdata.field,showlayout:true});
					  	}
					  	if(formdata.priority){
					  		this.setState({field_priorty_arr: formdata.priority});
						}

						if(formdata.text_size){
							this.setState({field_text_size_arr: formdata.text_size});
						}
						if(formdata.text_color){
							this.setState({field_text_color_arr: formdata.text_color});
						}
						if(formdata.count_size){
							this.setState({field_count_size_arr: formdata.count_size});
						}
					  	if(formdata.required){
					  		this.setState({field_required_arr : formdata.required});
					  	}
					  	if(formdata.fieldtype){
					  		this.setState({form_input_type_value_arr: formdata.fieldtype});
					  	}
					  	if(formdata.field_id){
					  		this.setState({field_ids: formdata.field_id});
					  	}
					  	if(formdata.options){
					  		this.setState({select_options_arr: formdata.options});
					  	}
					}
    		}
    	}

    if(Props.formedit !== this.props.formedit){

    		if(Object.keys(Props.formedit).length > 0){

    			this.setState({ Loading: false });

    			if(Props.formedit[0].status === "success"){
    				

						const formdata = Props.formedit[0].formdata;
						this.setState({form_name : formdata.formname});
						if(formdata.formcolumn == 1){
							this.setState({form_one_column: true,form_two_column: false});
						}else{
							this.setState({form_two_column: true,form_one_column:false})
						}
						if(formdata.formstatus === 'A'){
							this.setState({selectedOption:{value: 'active', label: 'Active'}});
						}else{
							this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
						}
					
					  	if(formdata.field){
					  		this.setState({name_arr: formdata.field,showlayout:true});
					  	}
					  	if(formdata.priority){
					  		this.setState({field_priorty_arr: formdata.priority});
						}
						
						if(formdata.count_size){
							this.setState({field_count_size_arr: formdata.count_size});
						}
						if(formdata.text_color){
							this.setState({field_text_color_arr: formdata.text_color});
						}
						if(formdata.text_size){
							this.setState({field_text_size_arr: formdata.text_size});
						}
					  	if(formdata.required){
					  		this.setState({field_required_arr : formdata.required});
					  	}
					  	if(formdata.fieldtype){
					  		this.setState({form_input_type_value_arr: formdata.fieldtype});
					  	}
					  	if(formdata.field_id){
					  		this.setState({field_ids: formdata.field_id});
					  	}
					  	if(formdata.options){
					  		this.setState({select_options_arr: formdata.options});
					  	}

					  	$('.success_message').html('<div class="status_sucess"><h3>'+ Props.formedit[0].message+'</h3></div>');
	                	scrollToTop();
	    				setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
					
    			}else{
    			$('.success_message').html('<div class="status_sucess"><h3>'+ Props.formedit[0].message+'</h3></div>');
                	scrollToTop();
    				setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
    		 }
    	}
    }
  }
  deletesinglefield(Index){
	  const itemToDelete = this.state.dashboarddata[Index];
	  const columnId = itemToDelete?.column_id;

	  const updatedDashboardData = [...this.state.dashboarddata];
	  updatedDashboardData.splice(Index, 1);

	  const blockCounts = {
		block1: updatedDashboardData.filter(item => item.dashboard_block === 'block1').length,
		block2: updatedDashboardData.filter(item => item.dashboard_block === 'block2').length,
		block3: updatedDashboardData.filter(item => item.dashboard_block === 'block3').length,
		block4: updatedDashboardData.filter(item => item.dashboard_block === 'block4').length
	  };

	  this.setState({dashboarddata: updatedDashboardData, blockCounts: blockCounts});

	  if(columnId) {
		this.setState(prevState => ({
		  remove_ids: [...prevState.remove_ids, columnId]
		}))
	  }
  }
  editsinglefield = (index) => {
	$('.error_name').html('');
		$('.error_module_type_value').html('');
		$('.error_priorty').html('');
		$('.error_count_size').html('');
		$('.error_text_color').html('');
		$('.error_text_size').html('');
		const editdata =  this.state.dashboarddata[index];
		this.setState({
			    name:editdata.column_name,
				priorty:editdata.priority,
				text_size:editdata.text_size,
				text_color:editdata.text_color,
				count_size:editdata.count_size,
				//content: editdata.content,
				editindex: index,
				dashboard_img_type:editdata.dashboard_img_type,
				dashb_img_max_height:editdata.dashb_img_max_height,
				dashb_img_max_width:editdata.dashb_img_max_width,
				dashb_img_position:editdata.dashb_img_position,
				dashboard_block: editdata.dashboard_block,
				show_tooltip: editdata.show_tooltip,
				show_count: editdata.show_count,
				icon_width: editdata.icon_width,
				icon_color: editdata.icon_color,
				image_preview: editdata.image_preview || "",
				db_image_name: editdata.db_image_name || editdata.image || '',
				bg_image_preview: editdata.bg_image_preview || "",
				db_bg_image_name:editdata.db_bg_image_name || editdata.bg_image
			 });
		if(editdata?.icon_color){
			const hex = editdata.icon_color;			
			const { filter, loss } = computeFilterFromHex(hex);
			this.setState({ 
				icon_color_filter: filter,
				icon_color_loss: loss,
			 });
		}
		
		const selectedblock = lang.common.dashboard_blocks.find(
			(opt) => opt.value === editdata.dashboard_block
			);

		const selectedlink = lang.common.dashboard_page_options.find(
			(opt) => opt.value === editdata.select_option
		);

		
		this.setState({
			dashboard_block_sel: selectedblock ? [selectedblock] : [],
			module_type: selectedlink,
			module_type_value:editdata.select_option
		});
		$('#addbutton').html('Update');
  }
  getformlayout(){
      var form_field_value = this.state.dashboarddata;
      if (form_field_value.length > 0) {
      const formlayout = form_field_value.map(
      (datas, Index) => {
      let indexdata = Index+1;
      return (
            <div key={Index+'list'}>
            <li className="sortablecontainer-module-list">
            {/* <i class="fa fa-chevron-right" aria-hidden="true"></i> */}
			<b>{indexdata}. </b>
            {datas.column_name || datas.name}
            <div className="d-flex gap-2 align-items-center" style={{float:"right"}}>
				<i className="ft-edit-3 position-relative cursor-pointer" aria-hidden="true" onClick={this.editsinglefield.bind(this,Index)} ></i>
				<i className="ft-trash-2 position-relative cursor-pointer" aria-hidden="true" onClick={this.deletesinglefield.bind(this,Index)}></i>
            {/* <button onClick={this.editsinglefield.bind(this,Index)} > Edit</button> */}
            {/* <button onClick={this.deletesinglefield.bind(this,Index, this.state.field_ids[Index])}> Delete</button> */}
            </div>
            </li></div> );

      }
      );
      return formlayout;
      }
  }
getdeleteall = () => {
  this.setState(prevState => ({
    showlayout: false,
    removeall_ids: prevState.dashboarddata
      .filter(item => item.column_id)
      .map(item => item.column_id)
  }));
};

handlefieldTypeChange(selectname,event) { 
	if(selectname=='link_to'){
       	this.setState({module_type:[event],module_type_value:event.value})

	}
	else{
       this.setState({dashboard_block_sel:[event],dashboard_block:event.value}, () => {
	   	console.log("State updated - dashboard_block is now:", this.state.dashboard_block);
		})
	}
}

handlefieldPositionChange(event) {   
	this.setState({dashb_img_position_ob:[event],dashb_img_position:event.value})
}
onChangeHandler = event => {
	let reader = new FileReader();
	const file = event.target.files[0];
	const Index = this.state.editindex;

	// Use existing image name if editing, otherwise create new name with incremented counter
	const imageName = (Index !== '' && this.state.dashboarddata[Index]?.image_name)
		? this.state.dashboarddata[Index].image_name
		: `image_${this.state.new_image_counter}`;

	reader.onloadend = () => {
		this.setState({
			image_name: imageName,
			image_preview: reader.result,
			image: file,
			db_image_name: '',
			new_image_counter: this.state.new_image_counter + 1
		});
	};
	reader.readAsDataURL(file);
}

onChangeIconHandler = event => {
	let reader = new FileReader();
	const file = event.target.files[0];
	const Index = this.state.editindex;

	// Use existing icon name if editing, otherwise create new name with incremented counter
	const iconName = (Index !== '' && this.state.dashboarddata[Index]?.icon_image)
		? this.state.dashboarddata[Index].icon_image
		: `icon_${this.state.new_image_counter}`;

	reader.onloadend = () => {
		this.setState({
			icon_name: iconName,
			icon_preview: reader.result,
			icon_image: file,
			icon_name_single: '',
			new_image_counter: this.state.new_image_counter + 1
		});
	};
	reader.readAsDataURL(file);
}

removeImagePreview = () => {
	this.setState({
		db_image_name: "",
		image_preview: "" 
	});
};

removeIconImagePreview = () => {
	this.setState({
		icon_preview: "",
		icon_name_single: ""
	});
};

removeBgImagePreview = () =>{
	this.setState({
		db_bg_image_name: "",
		bg_image_preview: "" 
	});
}

onChangeBgImgHandler = event => {
	let reader = new FileReader();
	const file = event.target.files[0];
	const Index = this.state.editindex;

	// Use existing bg image name if editing, otherwise create new name with incremented counter
	const bgImageName = (Index !== '' && this.state.dashboarddata[Index]?.bg_image_name)
		? this.state.dashboarddata[Index].bg_image_name
		: `bgimage_${this.state.new_bgimage_counter}`;

	reader.onloadend = () => {
		this.setState({
			bg_image_name: bgImageName,
			bg_image_preview: reader.result,
			bg_image: file,
			db_bg_image_name: '',
			new_bgimage_counter: this.state.new_bgimage_counter + 1
		});
	};
	reader.readAsDataURL(file);
}

onChangeBlockBgImgHandler = (index) => (event) => {
	let reader = new FileReader();
	const file = event.target.files[0];
	const block = this.state.dashboard_blocks[index];
	const title = lang.common.dashboard_blocks[index]?.value;
	// Use existing image name if block has one, otherwise create new name with incremented counter
	const blockImageName = (block?.image_name && block.image_name !== '')
		? block.image_name
		: `block_image_${this.state.block_image_counter}`;

	reader.onloadend = () => {
		const blocks = [...this.state.dashboard_blocks];
		blocks[index] = {
			...blocks[index],
			title: title,
			image: file,
			image_name: blockImageName,
			preview: reader.result,
			action: blocks[index]?.id ? 'edit' : 'add'
		};
		this.setState({
			dashboard_blocks: blocks,
			block_image_counter: this.state.block_image_counter + 1
		});
	};
	reader.readAsDataURL(file);
}

removeBlockBgImagePreview = (index) => {
	const blocks = [...this.state.dashboard_blocks];
	blocks[index] = {
		...blocks[index],
		image: '',
		preview: '',
		db_bl_image_name:'',
		image:'',
		image_name: '',
		action: blocks[index].id ? 'edit' : 'add'
	};
	this.setState({ dashboard_blocks: blocks });
}

  getDisabledBlockOptions = () => {
	const { blockCounts } = this.state;
	const blockOptions = lang.common.dashboard_blocks.map(block => {
		const blockCount = blockCounts[block.value] || 0;
		const isDisabled = blockCount >= block.columncount;
		return {
			...block,
			isDisabled: isDisabled
		};
	});
	blockOptions.push({ value: '', label: 'No block', columncount: 4 });
	return blockOptions;
   }
  render() {
  const {selectedOption,showlayout,login_type, db_image_name, icon_name_single,db_bg_image_name} = this.state;
			let preview = '';
			let iconPreview = null;
		
			if (db_image_name !=='') {
				const imagepre = mediaUrl+'dashboard/'+this.state.db_image_name;
				preview = <img className="img_class" src={imagepre} alt="" width={100} height={100}/>;
			}

			if(this.state.image_preview!==''){
					preview = <img className="img_class" src={this.state.image_preview} alt="" width={100} height={100}/>;
			}

			if (this.state.icon_name_single) {
				const url = mediaUrl + "dashboard/" + this.state.icon_name_single;
				iconPreview = (
					<img className="img_class" src={url} width={100} height={100} />
				);
			}

			// From uploaded file
			if (this.state.icon_preview) {
				iconPreview = (
					<img className="img_class" src={this.state.icon_preview} width={100} height={100} />
				);
			}
           let bgpreview ='';
		   
			if(db_bg_image_name !=='') {
				const bgimagepre = mediaUrl+'dashboard/'+db_bg_image_name;
				bgpreview = <img className="img_class" src={bgimagepre} alt="" width={100} height={100}/>;
			}
	
			if(this.state.bg_image_preview!==''){
					bgpreview = <img className="img_class" src={this.state.bg_image_preview} alt="" width={100} height={100}/>;
			}
  return (
   <div className="wrapper"> 
    <Header />
    <MenuSidebar  currentpage="dashboardmanagement"  currentTab="common" />		
    	<div className="content">	
    		<div className="content-wrapper">


			<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
    			<div className="success_message"></div>
				<div>
					<a class="primary-btn" href="/dashboardmanagement">Back</a>
				</div>
					<div className="title">
						<h4>Edit {this.state.login_type.value} dashboard</h4>
					</div>
    			<div className="content-body">
				<div className="builderpage-module-pagewrapper mb-0 pb-0">
						<div className="sortablecontainer-module-wrapper builderpage-module-section">
								<h2 className="typography-module-title">Blocks</h2>
								<div  className="form-row mb-0">
								{lang.common.dashboard_blocks.map((block, index) => (
									
										<div key={`block-${block.value}`} className={index / 2 === 0 ? "form-right" : "form-left"}>
										<div className="form-group">
											
											
											{this.state.dashboard_blocks[index]?.preview ? (
												<div className='d-flex gap-2 mt-2'>
													<label>Upload {block.label} background image :</label>
													<div className="choose-file">
												{this.state.isHidden && <div className="bg_image_success"></div>}
												<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeBlockBgImgHandler(index)} accept="image/*"/></span>
											</div>
													<img src={this.state.dashboard_blocks[index].preview} width={100} height={100} alt="preview" style={{maxHeight:"50px"}} />
													<span className='fw-bold cursor-pointer' onClick={() => this.removeBlockBgImagePreview(index)}>X</span>
												</div>
											) : this.state.dashboard_blocks[index]?.db_bl_image_name ? (
												<div className='d-flex gap-2 mt-2'>
													<label>Upload {block.label} background image :</label>
													<div className="choose-file">
												{this.state.isHidden && <div className="bg_image_success"></div>}
												<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeBlockBgImgHandler(index)} accept="image/*"/></span>
											</div>
													<img src={mediaUrl + 'dashboard/' + this.state.dashboard_blocks[index].db_bl_image_name} width={100} height={100} alt="preview" style={{maxHeight:"50px"}} />
													<span className='fw-bold cursor-pointer' onClick={() => this.removeBlockBgImagePreview(index)}>X</span>
												</div>
											):(
												<div className='d-flex gap-2 mt-2'>
												<label>Upload {block.label} background image :</label>
												<div className="choose-file">
												{this.state.isHidden && <div className="bg_image_success"></div>}
												<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeBlockBgImgHandler(index)} accept="image/*"/></span>
											</div>
											</div>
											)}
											<div className="errorloaderimage"></div>
										</div>
									
										{/* <label>Color (Background) ({block.label})<span class="required" style={{ color: "red" }} > * </span> : </label>
										<div className='d-flex form-field-accessibility-row'>
											<div className='form-field-accessibility-input'>
												<input type="text" className="form-control" value={this.state.dashboard_blocks[index]?.color || ''} onChange={(e) => this.handleDashboardBlockChange(index, 'color', e.target.value)}
												/>
											</div>
											<div className='form-field-accessibility-colorbx'>
												<input type="color" className="form-control" value={this.state.dashboard_blocks[index]?.color || ''} onChange={(e) => this.handleDashboardBlockChange(index, 'color', e.target.value)}
												/>
											</div>
										</div> */}
										{/* <div className="errorprimaryColor"></div> */}
									</div>
								))}
									</div>
							 </div> 
							 </div>
  			
        			<div className="builderpage-module-pagewrapper pt-2">

				

                <section className="builderpage-module-section">

			

				{this.state.dashboarddata.length > 0 && <> {(this.state.showlayout == true)?<> <h2 className="typography-module-title mt-5">{this.state.login_type_value} Menus <div className="sortablecontainer-module-delete-btn"><button onClick={this.getdeleteall.bind(this)}>Delete All</button></div></h2>
				     
                       <div className="sortablecontainer-module-wrapper">
						
                         <ul>
                           {this.getformlayout()}
                         </ul>

                      </div></>:''}</>}
                  </section>
				  <form className="BuilderPage-module-form builderpage-module-section" onSubmit={ (e) => { e.preventDefault(); this.handleFormSubmit(this); }}>

						{/* <div className="form-group">
							<label>Login Type:</label>
							<input type="text" className="form-control" placeholder="Login Type" name="login_type" value={this.state.login_type} onChange={this.handleInputChange} autoComplete="off"/>
						</div> */}
						<div className="form-group">					
						<label>User Type:</label>
						<input type="text" className="form-control" placeholder="Login Type" name="login_type" value={this.state.login_type.value} onChange={this.handleInputChange} autoComplete="off" readOnly/>
						{/* <Select 
						value={login_type?login_type:{ value: 'User', label: 'User'}}
						options={lang.common.login_type} 
						onChange={this.handleChange}
						/> */}
						</div>
						{/* <div className="form-group radio-check">
						<label>Choose layout</label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_yes" checked/>
								<label className="form-check-label" for="show_count_yes">
								One Column
								</label>
								<input className="form-check-input" type="radio" name="show_count" id="show_count_no" />
								<label className="form-check-label" for="show_count_no">
								Two Column
								</label>
						</div> */}
						{/* <div className="form-group">					
						<label>Status:</label>
								<Select 
								value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
								options={lang.common.status_option} 
								onChange={this.handleChange}
								/>
						</div> */}
						<h2 className="typography-module-title mt-5">{this.state.editindex !=''|| this.state.editindex =='0' ?"Edit Menu":"Add Menu"}</h2>
						<div className="form-group">
						<label>Title/Tooltip:</label>
						<input type="text" name="name" className="form-control" value={this.state.name} onChange={this.handleInputChange} autoComplete="off" />
						<div className="errorname"></div>
						</div>
						<div className="form-group radio-check">
							<label>Show Tooltip:</label>
							<input className="form-check-input" type="radio" name="show_tooltip"  value="yes" onChange={this.handleInputChange} checked={this.state.show_tooltip === 'yes'} />
								<label className="form-check-label" htmlFor="show_tooltip_yes"> Yes </label>
							<input className="form-check-input" type="radio" name="show_tooltip"  value="no" onChange={this.handleInputChange} checked={this.state.show_tooltip === 'no'} />
							<label className="form-check-label" htmlFor="show_tooltip_no"> No</label>
      					</div>

						<div className="form-group">
						<label>Link To: </label>
						<Select 
						value={this.state.module_type!=''?this.state.module_type:'Choose'}
						options={this.state.filtered_page_options} 
						onChange={this.handlefieldTypeChange.bind(this,'link_to')}
					
						isSearchable={false}
						/>
						<div className="errormodule"></div>
						</div>
						<div className="form-group">
						<label>Block: </label>
						<Select
						value={this.state.dashboard_block_sel!=''?this.state.dashboard_block_sel:''}
						options={this.getDisabledBlockOptions()}
						onChange={this.handlefieldTypeChange.bind(this,"dashboard_block")}
						isSearchable={false}
						/>
						<div className="errormodule"></div>
						</div>
						{/* {(this.state.module_type_value == 'select' || this.state.module_type_value == 'checkbox' || this.state.module_type_value == 'radio')?<div className="form-group">
						<label>Options:</label>
						<input type="text" name="select_options" className="form-control" value={this.state.select_options} placeholder="Enter options separate by ," onChange={this.handleInputChange} autoComplete="off" />
						<div className="erroroptions"></div>
						</div>:''} */}
						
						{/* <div className="form-group">
							<label>Content : </label>
							<input type="text" name="content" className="form-control" value={this.state.content} placeholder="Content" onChange={this.handleInputChange} autoComplete="off" />
						</div> */}

						{/* <div className="form-group">
						<label>Image:</label>
						<div className="choose-file">
						{this.state.isHidden && <div className="image_success"></div>}
						<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} /></span>
						</div>
						{preview!== '' && preview}
						<div className="errorloaderimage"></div>  
						</div>  */}
                        {/* <div className="form-group radio-check">
							<label>Dasboard Image Type</label>
							<input className="form-check-input" type="radio" name="dashboard_img_type" id="dashboard_img" value="dashboard_img" onChange={this.handleInputChange} checked={this.state.dashboard_img_type === 'dashboard_img'} />
							<label className="form-check-label" htmlFor="dashboard_img"> Image </label>
							<input className="form-check-input" type="radio" name="dashboard_img_type" id="dashboard_icon" value="dashboard_icon" onChange={this.handleInputChange} checked={this.state.dashboard_img_type === 'dashboard_icon'} />
							<label className="form-check-label" htmlFor="dashboard_icon"> Icon</label>
      					</div> */}

						<div className="form-group">
							<label>{this.state.dashboard_img_type === 'dashboard_icon' ? 'Icon' :'Icon'}:</label>

							{/* <label>{this.state.dashboard_img_type === 'dashboard_icon' ? 'Icon' :'Image'}:</label> */}
							<div className="choose-file">
								{this.state.isHidden && <div className="image_success"></div>}
								<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeHandler} accept="image/*"/></span>
							</div>
							{preview && preview !== '' && <div className='d-flex gap-2'>{preview} <span className='fw-bold cursor-pointer' onClick={this.removeImagePreview}>X</span></div>}
							<div className="errorloaderimage"></div>
						</div>
						{this.state.dashboard_img_type === 'dashboard_icon' &&(
							<>
								{/* <div className="form-group">
									<label>Dashboard icon max height (%):</label>
									<input type="text" name="dashb_img_max_height" className="form-control" value={this.state.dashb_img_max_height} onChange={this.handleInputChange} autoComplete="off" />
									<div className="errordashb_img_max_height"></div>
								</div>
								<div className="form-group">
									<label>Dashboard icon max width (%):</label>
									<input type="text" name="dashb_img_max_width" className="form-control" value={this.state.dashb_img_max_width} onChange={this.handleInputChange} autoComplete="off" />
									<div className="errordashb_img_max_width"></div>
								</div>
								<div className="form-group">
									<label>Dashboard icon position: </label>
									<Select 
									value={this.state.dashb_img_position_ob!=''? this.state.dashb_img_position_ob: { value: 'middle-center', label: 'Center' }}
									options={lang.common.dashboard_img_position} 
									onChange={this.handlefieldPositionChange.bind(this)}
								
									isSearchable={false}
									/>
									<div className="errordashb_img_position"></div>
								</div> */}
							</>
						)}
						<div className="form-group">
							<label>Icon width:</label>
							<input type="text" name="icon_width" className="form-control" value={this.state.icon_width}  onChange={this.handleInputChange} autoComplete="off" />
							<div className="erroriconwidth"></div>
						</div>
                        <div className="form-group">
							<label>Icon color:</label>
							<div className='d-flex form-field-accessibility-row'>
											<div className='form-field-accessibility-input'>
												<input type="text" className="form-control" name="icon_color" value={this.state.icon_color || ''} onChange={this.handleInputChange}
												/>
											</div>
											<div className='form-field-accessibility-colorbx'>
												<input type="color" className="form-control" name="icon_color" value={this.state.icon_color || ''}  onChange={this.handleInputChange}
												/>
											</div>
										</div>
										<div className="errorprimaryColor"></div>

						</div> 
						

						<div className="form-group">
							<label>Background image:</label>
							<div className="choose-file">
								{this.state.isHidden && <div className="bg_image_success"></div>}
								<span className="profile_btn"><input type="file" name="file" onChange={this.onChangeBgImgHandler} accept="image/*"/></span>
							</div>
							{bgpreview && bgpreview !== '' && <div className='d-flex gap-2'>{bgpreview} <span className='fw-bold cursor-pointer' onClick={this.removeBgImagePreview}>X</span></div>}
							<div className="errorloaderimage"></div>
						</div>  
                        {/* <div className="form-group">
							<label>Icon:</label>
							<div className="choose-file">
							{this.state.isHidden && <div className="image_success"></div>}
							<span className="profile_btn">
								<input type="file" name="file" onChange={this.onChangeIconHandler} accept="image/*"/>
							</span>
							</div>
							{iconPreview && iconPreview !== '' && ( <div className="d-flex gap-2"> {iconPreview} <span className="fw-bold cursor-pointer" onClick={this.removeIconImagePreview} > X </span> </div> )}
							<div className="errorloaderimage"></div>
						</div>  */}
						
						
						
						<div className="form-group radio-check">
							<label>Show Count</label>
							<input className="form-check-input" type="radio" name="show_count" id="show_count_yes" value="yes" onChange={this.handleInputChange} checked={this.state.show_count === 'yes'} />
								<label className="form-check-label" htmlFor="show_count_yes"> Yes </label>
							<input className="form-check-input" type="radio" name="show_count" id="show_count_no" value="no" onChange={this.handleInputChange} checked={this.state.show_count === 'no'} />
							<label className="form-check-label" htmlFor="show_count_no"> No</label>
      					</div>
						<div className="form-group">
							<label>Priority : </label>
							<input type="text" name="priorty" className="form-control" value={this.state.priorty}  onChange={this.handleInputChange} autoComplete="off" />
							<div className="errorpriority"></div>
						</div>
						<div className="form-group">
							<label>Text size:</label><br></br>
							<input type="input" id="head" name="text_size" className="form-control"  value={this.state.text_size} onChange={this.handleInputChange} />
							<div className="error_text_size"></div>
						</div>
					
						<div className="form-group">
							<label>Count size:</label><br></br>
							<input type="text" id="head" name="count_size" className="form-control"  value={this.state.count_size} onChange={this.handleInputChange} />
							<div className="error_count_size"></div>
						</div>

						<div className="form-group">
							<label>Text color:</label><br></br>
							<input type="color" id="head" name="text_color"  value={this.state.text_color} onChange={this.handleInputChange} />
							
							<div className="error_text_color"></div>
						</div>
						<div className='product-subscription-form-row mt-5'>
						<div className="submit-button">
						<span className="btn btn_orange btn_minwid login_submit animate-btn2" id="addbutton" onClick={this.Addtolayout}>Add</span>
						</div>
						<div className="">	
						<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true &&
											<span className="load-data"></span> 
											}Submit
						</button>
						</div>
						</div>
						</form>
          </div>
  			</div>	
			</div>
  		</div>	
  	</div>
  </div>
  );
  }
  }

export default (withRouter(Edit));